import React from 'react';
import { Modal, Button, Alert, Badge } from 'react-bootstrap';

const themeColor = '#00a8ff';

const InvoiceResultModal = ({ show, onClose, result, onNavigateToInvoice }) => {
  if (!result) return null;
  const { success, message, invoiceId, duplicateInvoiceIds, errorDetail } = result;
  const hasDuplicates = duplicateInvoiceIds && duplicateInvoiceIds.length > 0;

  return (
    <Modal show={show} onHide={onClose} centered backdrop="static" size={hasDuplicates ? 'lg' : ''}>
      <Modal.Header style={{ backgroundColor: success ? themeColor : '#dc3545', color: '#fff' }}>
        <Modal.Title className="w-100 text-center">
          <i className={success ? 'fa fa-check-circle mr-2' : 'fa fa-exclamation-triangle mr-2'}></i>
          {success ? 'Success' : 'Error'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center py-4">
        <p className="lead mb-3">{message}</p>

        {success && invoiceId && (
          <div className="bg-light rounded p-3 d-inline-block mb-3 border">
            <small className="d-block text-uppercase font-weight-bold text-muted mb-1">Invoice ID</small>
            <span
              className="h5 mb-0 font-weight-bold"
              style={onNavigateToInvoice ? { cursor: 'pointer', color: themeColor } : { color: themeColor }}
              onClick={() => onNavigateToInvoice && onNavigateToInvoice(invoiceId)}
            >
              <i className="fa fa-file-text-o mr-2"></i>{invoiceId}
            </span>
          </div>
        )}

        {success && hasDuplicates && (
          <Alert variant="warning" className="text-left mt-3">
            <strong><i className="fa fa-clone mr-2"></i>
              {duplicateInvoiceIds.length} Duplicate Invoice{duplicateInvoiceIds.length > 1 ? 's' : ''} Created
            </strong>
            <hr className="my-2" />
            {duplicateInvoiceIds.map((dupId, idx) => (
              <div key={idx} className="d-flex align-items-center py-1"
                style={onNavigateToInvoice ? { cursor: 'pointer' } : {}}
                onClick={() => onNavigateToInvoice && onNavigateToInvoice(dupId)}>
                <Badge variant="secondary" className="mr-2">#{idx + 1}</Badge>
                <span className="font-weight-bold">{dupId}</span>
              </div>
            ))}
          </Alert>
        )}

        {!success && errorDetail && (
          <Alert variant="warning" className="text-left mt-3">
            <i className="fa fa-info-circle mr-2"></i>{errorDetail}
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer className="justify-content-center border-0 pt-0">
        <Button style={{ backgroundColor: success ? themeColor : '#6c757d', borderColor: success ? themeColor : '#6c757d' }}
          onClick={onClose} className="px-5">
          {success ? 'OK' : 'Close'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InvoiceResultModal;
